module.exports = __webpack_public_path__ + "static/surrender_static-732cb6eaf1b96ff912529f38cb75942b.png";